import React from 'react';
import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="bg-white/60 backdrop-blur-lg border-t border-white/30 mt-12">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-8 py-8">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <div className="flex items-center space-x-3">
            <img 
              src="https://supabase.zapt.ai/storage/v1/render/image/public/icons/c7bd5333-787f-461f-ae9b-22acbc0ed4b0/55145115-0624-472f-96b9-d5d88aae355f.png?width=32&height=32" 
              alt="Zaptopia" 
              className="w-8 h-8 rounded-lg"
            />
            <div>
              <p className="text-slate-800 font-bold">Zaptopia</p>
              <p className="text-slate-600 text-sm">Find or create any app</p>
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6">
            {/* Legal Links */}
            <div className="flex items-center gap-4 text-sm">
              <Link 
                to="/privacy-policy" 
                className="text-slate-600 hover:text-indigo-600 transition-colors cursor-pointer"
              >
                Privacy Policy
              </Link>
              <span className="text-slate-400">•</span>
              <Link 
                to="/terms-of-service" 
                className="text-slate-600 hover:text-indigo-600 transition-colors cursor-pointer"
              >
                Terms of Service
              </Link>
              <span className="text-slate-400">•</span>
              <a 
                href="mailto:info@zapt.ai" 
                className="text-slate-600 hover:text-indigo-600 transition-colors cursor-pointer"
              >
                Contact
              </a>
            </div>
            
            {/* Made on ZAPT and Copyright */}
            <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-6 text-sm">
              <p className="text-slate-600">
                Made on{' '}
                <a 
                  href="https://www.zapt.ai" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:text-blue-800 font-semibold cursor-pointer transition-colors"
                >
                  ZAPT
                </a>
              </p>
              <p className="text-slate-500">
                © 2025 Zaptopia
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}